import * as TYPES from './_store/types';


import { usePageStore } from "@/store";

export function asyncData(store) {
    
    let ps = [];
    ps.push(usePageStore(this.$pinia).getCompanyInfo());
    let {
        agentIds,
        agentId,
        autoSort = false,
        queryAll,
        showAllAgents,
        pageSize,
        pageNum,
        useSwiperApiParams
    } = this;
    if (agentId) {
        agentIds = Array.from(new Set(agentIds.split(',')).add(agentId)).join(',');
    }
    ps.push(
        store[TYPES.FETCH_AGENTS]({
            queryAll,
            showAllAgents,
            agentIds,
            autoSort,
            pageSize,
            pageNum,
            useSwiperApiParams,
            initFlag: true
        })
    );
    return Promise.all(ps);
}
